import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "#191919",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.833.918a1.02 1.02 0 0 1 1.444 0L7 5.641 11.723.918a1.02 1.02 0 1 1 1.444 1.444L8.444 7.085l4.723 4.723a1.02 1.02 0 1 1-1.444 1.444L7 8.53l-4.723 4.723a1.021 1.021 0 0 1-1.444-1.444l4.723-4.723L.833 2.362a1.02 1.02 0 0 1 0-1.444Z"
  })));
};

export { SvgCross as ReactComponent };
//# sourceMappingURL=cross.svg.js.map
